// extracted by mini-css-extract-plugin
export default {"questionHeader":"styles_questionHeader__I2YP3","pageContent":"styles_pageContent__WOXIB"};